<template>
  <div
    class="pro_item"
    :class="[type == 'lazyloading' ? 'width100' : '', className, old == 1 ? 'old_pro_item' : '']"
  >
    <div class="img" @click="goDetail">
      <img v-lazy="prolistItem.img_path" />
      <img src="/static/images/shouqing.png" class="soldout" v-if="islimit == 2" />
      <img src="../../assets/images/soldout.png" class="soldout" v-else-if="issale == 0" />
      <img
        :src="prolistItem.goodsFloatImg"
        v-if="prolistItem.goodsFloatImg"
        class="pos-a l0 r0 b0"
        style="height: auto"
      />
      <goods-float-img
        :small-front="true"
        v-if="prolistItem.fullNFreeN && prolistItem.fullNFreeN.bgimg"
        class="pos-a l0 r0 b0"
        :full-n-free-n="prolistItem.fullNFreeN"
      ></goods-float-img>
    </div>
    <div class="tit over-ell-2" :class="[old == 1 ? 'f19' : '']" @click="goDetail">
      {{ prolistItem.name }}
    </div>
    <div class="price" @click="goDetail">
      <label class="xian">
        <sub :class="[old == 1 ? 'f22' : '']">¥</sub>
        <b
          :class="[old == 1 ? 'f24' : '']"
          v-text="
            String(prolistItem.sales_price).slice(0, String(prolistItem.sales_price).indexOf('.'))
          "
        ></b>
        <sup
          :class="[old == 1 ? 'f16' : '']"
          v-text="
            String(prolistItem.sales_price).slice(
              String(prolistItem.sales_price).indexOf('.'),
              String(prolistItem.sales_price).length
            )
          "
        ></sup>
      </label>
      <label class="yuan" :class="[old == 1 ? 'f15 ml14' : '']">
        ¥{{ prolistItem.cost_price }}
      </label>
      <div v-if="skuSwitch == '1'" class="opensku" @click.stop="openSku(prolistItem, prolistIndex)">
        <img src="/static/images/index/cart.png" />
      </div>
    </div>
    <ul class="integralTags" @click="goDetail">
      <li v-if="prolistItem.taglist" v-for="item of prolistItem.taglist">
        {{ item }}
      </li>
    </ul>
    <div class="desc" :class="[old == 1 ? 'f17 mt4' : '']" @click="goDetail">
      <div class="l">
        已售{{
          parseFloat(prolistItem.sales_num) / 10000 >= 1
            ? (parseInt(parseInt(prolistItem.sales_num) / 100) / 100).toFixed(2) + 'w'
            : prolistItem.sales_num
        }}
      </div>
      <div class="r">好评{{ prolistItem.comment_num }}</div>
    </div>
    <van-sku
      v-if="skuSwitch == '1'"
      close-on-click-overlay
      hide-quota-text
      v-model="showsku"
      :sku="sku"
      :goods="goods"
      :quota-used="quotaUsed"
      :goods-id="productId"
      :quota="quota"
      :hide-stock="sku.hide_stock"
      :custom-stepper-config="customStepperConfig"
      class="good_sku"
      ref="sku"
      @sku-selected="checkedSku"
      :initial-sku="initialSku"
    >
      <template slot="sku-header" slot-scope="props">
        <div class="van-sku-header van-hairline--bottom">
          <div class="van-sku-header__img-wrap">
            <img v-lazy="goods.picture" @click="openPreview" />
          </div>
          <div class="van-sku-header__goods-info">
            <div class="van-sku-name">{{ goods.title }}</div>
            <div class="van-sku-header-item">
              {{ skuname == '' ? '请选择商品规格' : '已选 ' + skuname }}
            </div>
            <div class="van-sku__goods-price">
              <span class="van-sku__price-symbol">¥</span>
              <span class="van-sku__price-num">{{ skuprice }}</span>
              <span class="van-sku__costprice-symbol">¥</span>
              <span class="van-sku__costprice-num">{{ skucostprice }}</span>
            </div>
            <!--<i class="van-icon van-icon-clear van-sku__close-icon" @click="showsku = false"></i>-->
          </div>
        </div>
      </template>

      <template slot="sku-actions" slot-scope="props">
        <div class="van-sku-actions">
          <van-button
            square
            size="large"
            type="danger"
            class="sure yellow"
            :class="{ sureGray: sureGray }"
            @click="onConfirmClicked(0)"
          >
            加入购物车
          </van-button>
          <van-button
            square
            size="large"
            type="danger"
            class="sure"
            :class="{ sureGray: sureGray }"
            @click="onConfirmClicked(1)"
          >
            立即购买
          </van-button>
        </div>
      </template>
    </van-sku>
    <sku-preview
      v-if="listItem.sku_rule_list"
      :hide-add-cart-button="
        changeSkuIndex >= 0 &&
        (listItem.sku_rule_list[changeSkuIndex].canbuycnt == 0 ||
          listItem.sku_rule_list[changeSkuIndex].issale == 0 ||
          listItem.sku_rule_list[changeSkuIndex].islimit == 2 ||
          listItem.sku_rule_list[changeSkuIndex].is_can_buy == 0)
      "
      :hide-buy-button="
        changeSkuIndex >= 0 &&
        (listItem.sku_rule_list[changeSkuIndex].canbuycnt == 0 ||
          listItem.sku_rule_list[changeSkuIndex].issale == 0 ||
          listItem.sku_rule_list[changeSkuIndex].islimit == 2 ||
          listItem.sku_rule_list[changeSkuIndex].is_can_buy == 0)
      "
      :show-sell-out-button="
        changeSkuIndex >= 0 &&
        (listItem.sku_rule_list[changeSkuIndex].canbuycnt == 0 ||
          listItem.sku_rule_list[changeSkuIndex].issale == 0 ||
          listItem.sku_rule_list[changeSkuIndex].islimit == 2 ||
          listItem.sku_rule_list[changeSkuIndex].is_can_buy == 0)
      "
      ref="skuPreview"
      :sku-list="listItem.sku_rule_list"
      @change="changePreview"
      @previewAddToCart="previewAddToCart"
      @previewBuyNow="previewBuyNow"
    />
  </div>
</template>

<script>
import { isWeixin, isApp, exclusiveidFn, pointParams } from '../../assets/common/js/config'
import { Sku } from 'vant'
import wx from 'weixin-js-sdk'
import skufunc from '../../assets/common/js/sku_func'
import skuPreview from '../common/skuPreview.vue'
import goodsFloatImg from '../common/goodsFloatImg'
import qs from 'qs'
export default {
  name: 'productItem',
  components: {
    [Sku.name]: Sku,
    skuPreview,
    goodsFloatImg
  },
  props: {
    markPointData: {
      // 埋点用
      type: Object,
      default: function () {
        return {}
      }
    },
    prolistItem: {
      type: Object,
      default: function () {
        return {}
      }
    },
    prolistIndex: {
      type: Number,
      default: 0
    },
    type: {
      type: String,
      default: ''
    },
    skuSwitch: {
      type: String,
      default: '0'
    },
    className: {
      type: String,
      default: ''
    },
    query: {
      type: Object,
      default: function () {
        return {}
      }
    },
    params: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data() {
    return {
      daiIndex: 0,
      zcIndex: 0,
      sureGray: false,
      skuprice: '197.00-218.90',
      skucostprice: '',
      skuId: null, // 总规格id 注： 传给后端的参数
      itemnum: null, // 购买数量 注：传给后端的参数
      productId: null,
      showsku: false,
      skuname: '',
      i: 0,
      quota: 0,
      quotaUsed: 0,
      sku: {
        tree: [],
        list: [],
        price: '1.00',
        stock_num: 227,
        collection_id: 2261,
        none_sku: false,
        hide_stock: false
      },
      goods: {
        title: '测试商品',
        picture: ''
      },
      listItem: {},
      itemIndex: null,
      initialSku: {},
      customStepperConfig: {
        quotaText: '每次限购xxx件',
        handleOverLimit: (data) => {
          const { action, limitType, quota, quotaUsed } = data
          if (action == 'minus') {
            this.$toast('至少选择一件商品')
          } else if (action == 'plus') {
            // let msg = `单次限购${quota}件`;
            // if (quotaUsed > 0) msg += `，你已购买${quotaUsed}`;
            let msg = `数量超出范围~`
            this.$toast(msg)
          }
        },
        handleStepperChange: (currentValue) => {},
        stockNum: 0,
        stockFormatter: (stockNum) => {}
      },
      productNum: 0,
      skuValueToast: null,
      islimit: 0,
      issale: 1,
      old: -1 /**app老年版标识 old=1 */,
      selectedSkuIndex: -1,
      changeSkuIndex: -1
    }
  },
  watch: {
    showsku(n) {
      this.$emit('showSku', n)
    }
  },
  mounted: function () {
    this.old = this.$route.query.old || 0
    if (this.prolistItem.sku_rule_list && this.prolistItem.sku_rule_list.length > 0) {
      let i = 0,
        j = 0
      this.prolistItem.sku_rule_list.map((item) => {
        if (item.islimit == 2) i++
        if (item.issale == 0) j++
      })
      if (i == this.prolistItem.sku_rule_list.length) this.islimit = 2
      if (j == this.prolistItem.sku_rule_list.length) this.issale = 0
    } else {
      if (typeof this.prolistItem.islimit != 'undefined') this.islimit = this.prolistItem.islimit
      if (typeof this.prolistItem.issale != 'undefined') this.issale = this.prolistItem.issale
    }
  },
  methods: {
    goDetail() {
      var id = this.prolistItem.itemid ? this.prolistItem.itemid : this.prolistItem.item_base_id
      var that = this
      if (this.type != 'lazyloading' && this.type != 'notScrollTo') {
        // window.scrollTo(0, 0)
      } else {
        this.$clickburiedPoint({
          data: {
            buttonCode: 'indexprod-' + id
          },
          callback: () => {
            f()
          }
        })
        return
      }
      f()
      function f() {
        let data = that.markPointData
        data.itemid = id
        that.$clickburiedPoint({
          url: 'ckysdatacenter/itemclick/save',
          data: data
        })
        if (that.prolistItem.product_detail && that.prolistItem.product_detail == 1) {
          that.$router.replace({
            path: '/productdetail',
            query: {
              ...that.query,
              itemid: id
            }
          })
          that.$emit('itemid', that.prolistItem.item_base_id)
        } else {
          var arg = isApp()

          if (arg == '') {
            that.$router.push({
              path: '/productdetail',
              query: {
                ...that.query,
                itemid: id
              }
            })
          } else if (arg.indexOf('xcx') < 0) {
            if (that.params.payMethods == 2) {
              that.$dialog
                .alert({
                  title: '温馨提示',
                  message: '当前系统不支持该链接查询，请关注"创客村"公众号查看详情',
                  confirmButtonText: '我知道了',
                  className: 'percen_button_alert',
                  confirmButtonColor: '#FFFCFC',
                  closeOnPopstate: true
                })
                .then(() => {})
            } else {
              window.ReactNativeWebView.postMessage(
                JSON.stringify({
                  type: 'goItemDetail',
                  ...that.query,
                  itembaseid: id
                })
              )
            }
          } else {
            if (that.params.payMethods == 2) {
              that.$dialog
                .alert({
                  title: '温馨提示',
                  message: '当前系统不支持该链接查询，请关注"创客村"公众号查看详情',
                  confirmButtonText: '我知道了',
                  className: 'percen_button_alert',
                  confirmButtonColor: '#FFFCFC',
                  closeOnPopstate: true
                })
                .then(() => {})
            } else {
              wx.miniProgram.navigateTo({
                url:
                  '/pages/product/main?itemid=' +
                  id +
                  '&' +
                  qs.stringify(that.query) +
                  '&backInit=1' +
                  '&exclusiveid=' +
                  exclusiveidFn() +
                  pointParams('&')
              })
            }
          }
        }
      }
    },
    openPreview() {
      this.changeSkuIndex = this.selectedSkuIndex
      this.$refs.skuPreview.showPreview(this.selectedSkuIndex)
      skufunc.selectedSkuHandle(this.selectedSkuIndex, this)
    },
    changePreview(index) {
      this.changeSkuIndex = index
      skufunc.selectedSkuHandle(index, this)
    },
    previewAddToCart() {
      skufunc.onConfirmClicked_proitem(0, this)
    },
    previewBuyNow() {
      skufunc.onConfirmClicked_proitem(1, this)
    },
    openSku(item, index) {
      skufunc.openSku_proitem(item, index, this)
    },
    checkedSku(skuValue) {
      skufunc.checkedSku_proitem(skuValue, this)
    },
    onConfirmClicked(type) {
      skufunc.onConfirmClicked_proitem(type, this)
    },
    // 埋点
    dataCollection(dataType) {
      let params = {
        productId_var: this.listItem.itemid,
        productName_var: this.listItem.name,
        firstCat_var: this.listItem.brand,
        productType_var: '',
        productFormat_var: this.skuId
      }
      console.log(dataType, params)
      gio('track', dataType, params)
    }
  }
}
</script>

<style scoped lang="scss">
.pro_item {
  width: 50%;
  /*height: 2.74rem;*/
  margin-bottom: 0.16rem;
  float: left;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  &.width100 {
    width: 100%;
    background: #ffffff;
    overflow: hidden;
    border-radius: 0.1rem;
    margin-bottom: 0.12rem;
    .tit,
    .desc {
      margin: 0.08rem 0.07rem;
    }
    .tit {
      margin-bottom: 0;
      height: auto;
    }
    .integralTags,
    .price {
      margin: 0 0.07rem;
    }
    .desc {
      margin-top: 0;
      overflow: hidden;
    }
  }
  .img {
    width: 100%;
    height: 0;
    padding-bottom: 100%;
    position: relative;
    /*height: 1.73rem;*/
    img {
      width: 100%;
      height: 100%;
      position: absolute;
      /*height: 100%;*/
    }
    .soldout {
      width: 59%;
      height: 59%;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      margin: auto;
    }
  }
  .tit {
    margin-top: 0.12rem;
    font-size: 0.13rem;
    line-height: 0.18rem;
    height: 0.36rem;
    color: #292929;
  }
  .integralTags {
    padding: 0;
    display: flex;
    flex-wrap: wrap;
    margin-top: -0.07rem !important;
    margin-bottom: 0.04rem !important;
    li {
      margin: 0;
      border: 0.01rem solid #ff655a;
      border-radius: 0.03rem;
      color: #ff655a;
      font-size: 0.08rem;
      padding: 0.01rem 0.03rem;
      width: auto;
      margin-right: 0.05rem;
      margin-top: 0.03rem;
    }
  }
  .price {
    margin-top: 0.1rem;
    font-size: 0.14rem;
    overflow: hidden;
    .xian {
      color: #fc0324;
      font-size: 0;
      line-height: 0.2rem;
      b {
        font-size: 0.14rem;
        font-weight: 600;
      }
      sub {
        font-weight: normal;
        font-size: 0.12rem;
        vertical-align: baseline;
      }
      sup {
        font-size: 0.11rem;
        vertical-align: baseline;
        font-weight: normal;
      }
    }
    .yuan {
      font-size: 0.12rem;
      transform: scale(0.85);
      color: #6c6c6c;
      text-decoration: line-through;
    }
    .opensku {
      width: 0.19rem;
      height: 0.19rem;
      float: right;
      img {
        width: 100%;
      }
    }
  }
  .desc {
    font-size: 0.11rem;
    line-height: 0.16rem;
    color: #6c6c6c;
    /*margin-top: -0.06rem;*/
    .l {
      float: left;
    }
    .r {
      float: right;
    }
  }
}
.pro_item.old_pro_item {
  .tit {
    height: 0.52rem;
    line-height: 0.25rem;
  }
}
</style>

<style lang="scss">
.pro_item {
  .good_sku {
    .van-icon-cross {
      background: url('../../assets/images/close3.png') no-repeat center;
      background-size: 100%;
      color: transparent;
    }
  }
  .van-button--danger.sure {
    background: linear-gradient(90deg, #f63a66 0%, #fc0324 100%);
  }
  .van-button--danger.yellow {
    background: linear-gradient(90deg, #ffa700 0%, #ffba00 100%);
  }
}
.pro_item {
  .good_sku .van-sku-stepper-stock {
    display: block !important;
  }
  .good_sku .van-sku-row__item {
    border-radius: 0.15rem;
    font-size: 0.13rem;
    color: #5e5e5e;
    padding: 0 0.1rem;
    border: solid 1px transparent;
  }
  .good_sku .van-sku-row__item::before {
    background: #eeeff4;
  }
  .good_sku .van-sku__goods-price {
    margin-top: 0.2rem;
  }
  .good_sku .van-sku__price-symbol,
  .van-sku__price-num {
    font-size: 0.16rem;
    color: #fc0324;
    font-weight: 600;
  }
  .good_sku .van-sku__costprice-symbol {
    margin-left: 0.05rem;
  }
  .good_sku .van-sku__costprice-symbol,
  .van-sku__costprice-num {
    font-size: 0.12rem;
    color: #979797;
    font-weight: normal;
    line-height: 0.2rem;
    text-decoration: line-through;
  }
  .good_sku .van-sku-row__item--active {
    border: solid 1px #fc0324;
    background-color: #fcedeb;
    color: #fc0324;
  }
  .good_sku .van-sku-row__item-name {
    padding: 0.06rem;
  }
  .good_sku .van-sku-row__item-img {
    width: 0.2rem;
    height: 0.2rem;
  }
  .good_sku.van-popup--bottom.van-popup--round {
    border-radius: 0;
    padding-bottom: 0.6rem;
  }
  .good_sku .van-sku-row__title,
  .van-sku__stepper-title {
    padding-bottom: 0.13rem;
    font-size: 0.13rem;
    color: #333333;
    line-height: 0.18rem;
    font-weight: 600;
  }
  .good_sku .van-sku__stepper {
    border-radius: 0.13rem;
    overflow: hidden;
  }
  .good_sku .van-stepper__minus,
  .van-stepper__plus,
  .van-stepper__input {
    height: 0.22rem;
  }
  .good_sku .van-stepper__minus::before,
  .van-stepper__plus::before {
    width: 9px;
  }
  .good_sku .van-stepper__minus::after,
  .van-stepper__plus::after {
    height: 9px;
  }
  .good_sku .van-sku-row__item--disabled {
    background: #fcfcfc;
    border-radius: 0.15rem;
    border: 1px solid #eeeff4;
    color: #dedede;
    &:before {
      background: #fcfcfc;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/productItem.vue